import React, { useEffect } from "react";
import { MessageCircle, ShoppingBag, FileText } from "lucide-react";
import { useCart } from "../contexts/CartContext";

const WHATS = "https://wa.me/5519992923017?text=Ol%C3%A1%20Biofarmax!%20Quero%20fazer%20meu%20or%C3%A7amento";

export default function StickyMobileCTA() {
  const { count, setOpen } = useCart();

  useEffect(() => {
    document.body.classList.add("has-sticky-cta");
    return () => document.body.classList.remove("has-sticky-cta");
  }, []);

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden px-3 pb-3 pt-2"
      data-testid="sticky-mobile-cta"
      style={{
        background: "linear-gradient(180deg, rgba(250,250,248,0) 0%, rgba(250,250,248,0.95) 30%)",
      }}
    >
      <div className="flex items-center gap-2 glass-card rounded-full p-1.5 shadow-[0_20px_50px_-15px_rgba(15,15,15,0.35)]">
        <a
          href={WHATS}
          target="_blank"
          rel="noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 px-4 rounded-full font-tech text-sm font-semibold shadow-[0_10px_20px_-8px_rgba(37,211,102,0.6)]"
          data-testid="sticky-whatsapp"
          aria-label="WhatsApp"
        >
          <MessageCircle size={18} strokeWidth={2} />
          <span>WhatsApp</span>
        </a>
        <a
          href={WHATS}
          target="_blank"
          rel="noreferrer"
          className="flex-1 flex items-center justify-center gap-2 bg-brand-primary text-white py-3 px-4 rounded-full font-tech text-sm font-semibold"
          data-testid="sticky-receita"
          aria-label="Enviar receita"
        >
          <FileText size={18} strokeWidth={1.8} />
          <span>Receita</span>
        </a>
        <button
          onClick={() => setOpen(true)}
          className="relative p-3 bg-brand-accent text-white rounded-full"
          data-testid="sticky-cart"
          aria-label="Carrinho"
        >
          <ShoppingBag size={18} strokeWidth={1.8} />
          {count > 0 && (
            <span className="absolute -top-1 -right-1 bg-white text-brand-accent text-[10px] font-bold rounded-full w-5 h-5 grid place-items-center border border-brand-accent">
              {count}
            </span>
          )}
        </button>
      </div>
    </div>
  );
}
